export const toCamelCase = (str) =>
  str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase()
    )
    .replace(/\s+/g, '')

export const truncateText = (text, maxLength) => {
  // Handle undefined, null, or non-string values
  if (!text || typeof text !== 'string') {
    return ''
  }

  if (text.length > maxLength) {
    return `${text.substring(0, maxLength - 3)}...`
  }

  return text
}

export const isEncoded = (str) => {
  try {
    return str !== decodeURIComponent(str)
  } catch (e) {
    return false
  }
}

// Generates a URL-safe slug suitable for element IDs and fragments
export const toSlug = (text) => {
  if (text == null) {
    return ''
  }

  const str = String(text).toLowerCase().trim()
  let result = ''
  let prevWasDash = false

  for (let i = 0; i < str.length; i++) {
    const char = str[i]
    const isValidChar = (char >= 'a' && char <= 'z') || (char >= '0' && char <= '9')

    if (isValidChar) {
      result += char
      prevWasDash = false
    } else if (!prevWasDash && result.length > 0) {
      result += '-'
      prevWasDash = true
    }
  }

  // Remove trailing dash if present
  if (result.endsWith('-')) {
    result = result.slice(0, -1)
  }

  return result
}
